import { Flex, Text } from "@chakra-ui/react";
import {
  formatMoney
} from "../utils";
import { FaBell } from "react-icons/fa";
import Image from "next/image";

const MinAmountInfo = ({ labels, amounts, currency, reactIcon: Icon, ...props }) => {
  return (
    <Flex
      w="100%"
      px={4}
      py={3}
      bg="#EAEFED"
      borderRadius={6}
      border="1px solid #BEC1C1"
      align="center"
      gap={2}
      mt={2}
      mb={2}
      {...props}
    >
      <Flex align="center" gap={2}>
        {Icon && <Icon style={{ marginRight: '8px' }} />}
        <Flex direction="column" gap={1}>
          <Text
            fontSize="14px"
            fontFamily="IBM Plex Mono"
            fontWeight={400}
            color="black"
          >
            {labels.map((label, index) => (
              <span key={index}>
                {label}
                <Text as="span" color="#F56565" fontWeight={700}>
                  {` ${formatMoney(amounts[index], { currency })}`}
                </Text>
                {index < labels.length - 1 && " | "}
              </span>
            ))}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MinAmountInfo;